import {Box, Link, Stack, Typography} from '@mui/material';
import parse from 'html-react-parser';
import {displayPastDuration} from '../helper/date';
import {styled} from '@mui/material/styles';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import NotificationsIcon from '@mui/icons-material/Notifications';

const Img = styled('img')({
  width: 45,
  height: 45,
  borderRadius: '50%',
});

const NotificationItem = ({
  title,
  message,
  createdAt,
  image,
  isPending,
  actionUrl,
  markAsReaded,
    notificationId
}) => {
  const {mode} = useDarkMode();
  const timeElapsed = new Date() - new Date(createdAt * 1000);
  const oneMinute = 60 * 1000;

  return (
    <Stack
      p={3}
      flexDirection="row"
      sx={{
        borderBottom: '1px solid #D9D9D9',
        position: 'relative',
        '&:last-of-type': {
          borderBottom: 'none',
        },
      }}
      alignItems="center"
      gap={3}>
      {isPending && (
        <Box
          sx={{
            width: 10,
            height: 10,
            backgroundColor: '#DD809D',
            borderRadius: 10,
            position: 'absolute',
            top: 20,
            left: 0,
          }}
        />
      )}
      {image && (
        <Box
          sx={{
            alignSelf: 'baseline',
            marginTop: 2,
            background: `url(${image.base64})`,
            width: 45,
            height: 45,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            borderRadius: '50%',
          }}
        />
      )}

      {!image &&
          <NotificationsIcon sx={{
              fontSize: 45,
              color: mode.darkMode ? 'white' : 'black',
          }}/>
      }
      <Stack gap={1}>
        <Link
        onClick={(event) => {
            event.preventDefault();
            markAsReaded(notificationId).then(() => {
                window.location.href = actionUrl ?? '#';
            });
        }}
          sx={{
            textDecoration: 'none',
            color: mode.settings.textColor3,
            cursor: 'pointer',
          }}>
          <Typography>{parse(title)}</Typography>
        </Link>
        <Stack direction="row">
          <Box
            sx={{
              width: 6,
              backgroundColor: '#DDDEE1',
              height: 'auto',
              borderRadius: 5,
            }}
          />
          <Typography
            sx={{color: '#7a7a7a', fontSize: '14px', marginLeft: '-15px'}}
            pl={3}>
            {parse(message)}
          </Typography>
        </Stack>
      {timeElapsed >= oneMinute && (
          <Typography sx={{color: '#A5ACB8', fontSize: 12}}>
              il y a {displayPastDuration(new Date(createdAt * 1000))}
          </Typography>
      )}
      </Stack>
    </Stack>
  );
};

export default NotificationItem;
